import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AuthRedirect from "../../components/hoc/AuthRedirect";
import axios from "../../api/axios";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../components/form/InputField";
import { useDispatch, useSelector } from "react-redux";
import { setConfigError } from "../../features/configSlice";
import Loading from "../../components/loading/Loading";
import { zodResolver } from "@hookform/resolvers/zod";
import { inviteRegisterSchema } from "../../schemas";
import { inviteRegisterUser } from "../../features/userSlice";
import { useNotification } from "../../components/notification/NotificationContainer";
import loadStatus from "../../util/loadStatus";

const InviteRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [invite, setInvite] = useState({});
  const [loading, setLoading] = useState(true);
  const { token } = useParams();
  const addNotification = useNotification();
  const loadInviteRegister = useSelector(
    (state) => state.user.load.inviteRegisterUser
  );
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({ resolver: zodResolver(inviteRegisterSchema) });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    let res;
    try {
      res = await dispatch(inviteRegisterUser({ token, data })).unwrap();
      // if()
      navigate("/dashboard");
    } catch (error) {}
  };

  const getInvite = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/invite-register/" + token);
      setLoading(false);
      setInvite(res.data);
      reset({ email: res.data.email });
    } catch (error) {
      if (error.response.data) {
        setLoading(false);
        addNotification(error.response.data.message, "error");
        return navigate("/error", { replace: true });
      } else {
        setLoading(false);
        addNotification(error.message, "warning");
        return navigate("/error", { replace: true });
      }
    }
  }, [setInvite]);

  useEffect(() => {
    getInvite();
  }, []);

  if (loading) {
    <Loading />;
  } else
    return (
      <AuthRedirect>
        <div className="auth-container">
          <div className="auth-content-md ">
            <div className=" auth-inner-content ">
              <h3 className="auth-title mb-7">Invite Register</h3>
              {invite.id && (
                <div className="rounded-md border-2 border-bkg2 bg-bkg text-text-1/60 my-6 p-2 ">
                  <p>
                    <span className="text-text-1/80">Country: </span>
                    <span>{invite.organization}</span>
                  </p>
                  {invite.community && (
                    <p>
                      <span className="text-text-1/80">Community:</span>
                      <span>{invite.community}</span>
                    </p>
                  )}
                  <p>
                    <span className="text-text-1/80">Role: </span>
                    <span>{invite.role}</span>
                  </p>
                  <p>
                    <span className="text-text-1/80">Email: </span>
                    <span>{invite.email}</span>
                  </p>
                </div>
              )}
              <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <div className="flex flex-col justify-between items-center gap-3 sm:flex-row p-1">
                  {" "}
                  <InputField
                    register={register}
                    errors={errors.first_name}
                    label="First Name"
                    name="first_name"
                    type="text"
                  />
                  <InputField
                    register={register}
                    errors={errors.last_name}
                    label="Last Name"
                    name="last_name"
                    type="text"
                  />
                </div>
                <div className="flex flex-col justify-between items-center gap-3 sm:flex-row p-1">
                  <InputField
                    register={register}
                    errors={errors.other_names}
                    label="Other Names"
                    name="other_names"
                    placeholder="Kojo"
                    type="text"
                  />
                  <InputField
                    register={register}
                    errors={errors.email}
                    label="Email"
                    name="email"
                    placeholder="david@examplie.com"
                    type="email"
                    autoComplete="false"
                  />
                </div>
                <div className="flex flex-col justify-between items-center gap-3 sm:flex-row p-1">
                  {" "}
                  <InputField
                    register={register}
                    errors={errors.password}
                    label="Password"
                    name="password"
                    type="password"
                  />
                </div>
                <div className="flex flex-col justify-between items-center gap-3 sm:flex-row p-1">
                  <InputField
                    register={register}
                    errors={errors.confirm_password}
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                  />
                </div>
                <button
                  type="submit"
                  className="auth-btn my-8"
                  disabled={loadInviteRegister === loadStatus.loading}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </AuthRedirect>
    );
};

export default InviteRegister;
